/* istanbul ignore file */
/**
 * Created by gboue on 8/22/22
 * File: AddOwnerModal
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { VFC, useCallback, CSSProperties } from 'react'
import {
  Modal,
  ModalHeader, ModalProps,
} from '@panwds/react-ui'
import {
  TITLE_ADD_OWNER,
} from '../../../constants/LabelConstants'
import AdditionalOwnersForm from '../forms/AdditionalOwnersForm'

const AddOwnersModal: VFC<ModalProps & {
  closeModal: () => void,
  domain: string,
  fetchData: Function
}> = ({ isOpen, closeModal, domain, fetchData }) => {

  const onCancelPressed = useCallback(() => {
    closeModal()
  }, [closeModal])

  return (
    <Modal
      size='lg'
      style={{ top: '50%', '--tw-translate-y': '-50%', minHeight: '600px', minWidth: '800px' } as CSSProperties}
      onClose={closeModal}
      {...{ isOpen }}
    >
      <ModalHeader title={TITLE_ADD_OWNER} />
      <AdditionalOwnersForm {...{ onCancelPressed, domain, fetchData }} />
    </Modal>
  )
}

AddOwnersModal.propTypes = {}
export default AddOwnersModal
